import { useMutation, useQueryClient } from "@tanstack/react-query";

import { addFieldPracticeParticipations } from "services";

import { invalidateFieldParticipationQueries } from "utils";

import { ADD_FIELD_PRACTICE_PARTICIPATIONS } from "consts";

export const useAddFieldPracticeParticipations = (fieldIds: string[], farmId?: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: [ADD_FIELD_PRACTICE_PARTICIPATIONS],
    mutationFn: addFieldPracticeParticipations,
    onSuccess: () => invalidateFieldParticipationQueries(queryClient, fieldIds, farmId),
  });
};
